<template>

<div class="ancillaries">
    <div class="row">
        <div class="col-1">
        </div>
        <div class="col-10">
            <div class="svg-knob-elevation-and-text" @click="previousStep()">
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.603448" y="0.603448" width="23.7931" height="23.7931" rx="9.39655"
                        :stroke="data.brand.whitelabel_config.fontColor" stroke-width="1.2069" />
                    <path
                        d="M14 17.75C13.7891 17.75 13.6016 17.6797 13.4609 17.5391L8.96094 13.0391C8.65625 12.7578 8.65625 12.2656 8.96094 11.9844L13.4609 7.48438C13.7422 7.17969 14.2344 7.17969 14.5156 7.48438C14.8203 7.76562 14.8203 8.25781 14.5156 8.53906L10.5547 12.5L14.5156 16.4844C14.8203 16.7656 14.8203 17.2578 14.5156 17.5391C14.375 17.6797 14.1875 17.75 14 17.75Z"
                        :fill="data.brand.whitelabel_config.fontColor" />
                </svg>
                <p class="your-cart-text mb-0" :style="{ color: data.brand.whitelabel_config.fontColor }">{{
                    data.text.your_cart }}</p>
            </div>
        </div>
    </div>
 


    <div class="total-cart-container row">
        <div class="col-1 p-0">
            <div class="flight-left-cart" data-bs-target="#flightCarousel" data-bs-slide="prev">
            </div>
        </div>
        <div class="col-10 p-0">
            <div class="flight-cart" :style="{ background: data.brand.whitelabel_config.cartBackgroundColor }">
                <div class="mb-3">
                            <label for="email" :style="{ color: data.brand.whitelabel_config.fontColor2 }">{{data.text.enter_your_email}}</label>
                                <input
                                    type="email"
                                    id="email"
                                    :value="email"
                                    @input="validateEmail({email:$event.target.value})"
                                  
                                    class="form-control"
                                    :class="{ 'is-invalid': emailError }"
                                    placeholder="example@email.com"
                                />
                                <div v-if="emailError" class="invalid-feedback">
                                    {{ emailError }}
                                </div>
                        </div>
            </div>
        </div>
        <div class="col-1 p-0 text-end" data-bs-target="#flightCarousel" data-bs-slide="next">
            <div class="flight-right-cart">

            </div>
        </div>
    </div>
</div>

    <nav class="checkout-container" :style="{ background: data.brand.whitelabel_config.mainBackgroundColor }">
              <div class="container-fluid row">
                <div class="col-1">
                </div>
                <div class="col-10 p-0">
                  <button class="checkout" @click="updateEmail()" :disabled="disableEmailCheckout"
                    :style="{ background: data.brand.whitelabel_config.buttonBackgroundColor, color: data.brand.whitelabel_config.buttonTextColor, border: data.brand.whitelabel_config.buttonBackgroundColor }">{{
                      data.text.checkout }}</button>
                </div>
              </div>
            </nav>

</template>

<script>
import { mapActions,  mapState, mapGetters } from "vuex";
export default {
    props: ['data'],

    computed: {
    ...mapGetters(['disableEmailCheckout']),
    ...mapState(["email", "emailError"]) 
    },
    mounted() {
        window.scrollTo(0, 0);
    },

    methods: {
        ...mapActions(['previousStep', 'validateEmail', 'updateEmail']), 
    }



}
</script>

<style scoped>
.checkout-container .container-fluid {
  margin: 0px;
  padding: 0px;
}

.checkout-container .checkout {
  /* font-family: Figtree; */
  font-size: 12px;
  font-weight: 800;
  line-height: 14.4px;
  width: 100%;
  text-align: center;
  height: 50px;
  border-radius: 18px;
  margin: 0px;
  padding: 0px;
  text-transform: uppercase;
}

.checkout-container {
  height: 80px;
  /* background-color: #F1F1F1 !important; */
  position: sticky;
  bottom: 0;
  z-index: 999;
}



.ancillaries {
  /* background: #F1F1F1; */
  min-height: calc(100vh - 80px);
  padding: 0px;
  overflow-x: hidden;
}

.checkout:disabled {
  cursor: not-allowed !important;
  opacity: 0.5;
}
 
.vat-included {
    /* font-family: Figtree; */
    font-size: 12px;
    font-weight: 700;
    line-height: 14.4px;
    text-align: left;
    display: flex;
    align-items: center;
    color: #4C4C4C;
    padding: 3px 5px 0px 5px;
}

.total-text-container {
    display: flex;
    align-items: center;
}

.total-price {
    /* font-family: Figtree; */
    font-size: 30px;
    font-weight: 800;
    line-height: 36px;
    text-align: center;
}

.total-text {
    /* font-family: Figtree; */
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    color: #000000;
}


.total-cart-container {
    margin: 40px 0px 40px 0px;
}

.service-price {
    /* font-family: Figtree; */
    font-size: 12px;
    font-weight: 700;
    line-height: 14.4px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

}

.service-name {
    /* font-family: Figtree; */
    font-size: 12px;
    font-weight: 700;
    line-height: 14.4px;
    text-align: left;
    display: flex;
    align-items: center;
    color: #4C4C4C;

}


.flight-cart-info {
    border-bottom: 0.5px solid #999999;
    margin-top: 30px;
}

.airline-svg {
    margin: 0px 3px 2px 3px
}

.cart-airport-flight {
    /* font-family: Figtree; */
    font-size: 14.57px;
    font-weight: 800;
    line-height: 17.49px;
    text-align: left;
    color: #000000;
    white-space: nowrap;
    display: flex;
    align-items: center;
    padding: 0px;
    justify-content: flex-end;
}

.cart-airport-flight[aria-expanded="false"] .chevron-down svg {
    transform: rotate(180deg);
}

.chevron-down {
    padding-bottom: 6px;
    padding-left: 24px;

}

.airline-info {
    /* min-width: 117px; */
    padding: 0px 15px 0px 15px;
    height: 29.71px;
    border-radius: 10px;
    background-color: #000;
    color: #FFFFFF;
    border: none;
    outline: none;
    cursor: pointer;
    /* font-family: Figtree; */
    font-size: 12px;
    font-weight: 800;
    line-height: 14.4px;
    text-align: center;

}

.flight-info {
    padding: 21px 22px 21px 22px;
}

.flight-cart {
    min-height: 67px;
    border-radius: 25px;
    background-color: #ffffff;
    padding: 20px;
}

.flight-left-cart {
    margin-top: 11px;
    /* height: 163px; */
    border-radius: 0px 22px 22px 0px;
    margin-right: 8px;
}

.flight-cart-container {
    margin: 15px 0px 0px 0px;
}

.svg-knob-elevation-and-text {
    margin-top: 30px;
    display: inline-flex;
}

.your-cart-text {
    padding-left: 16px;
    /* font-family: Figtree; */
    font-size: 14px;
    font-weight: 600;
    line-height: 16.8px;
    display: flex;
    align-items: center;
    color: #000000;
}
</style>